import { render, staticRenderFns } from "./ProjectSkillAdd.vue?vue&type=template&id=0f1fd0b4&scoped=true"
import script from "./ProjectSkillAdd.vue?vue&type=script&lang=js"
export * from "./ProjectSkillAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1fd0b4",
  null
  
)

export default component.exports